import { User } from "../types"

export type NotificationProps = {
    type?: string,
    text?: string
}

export const ADD_NOTIFICATION = "ADD_WAIT"
export const REMOVE_NOTIFICATION = "REMOVE_WAIT"